import React from 'react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Textarea } from '../../ui/textarea';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../ui/dialog';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../ui/select';

export const ResetPasswordDialog = ({
  open,
  onOpenChange,
  selectedUser,
  newPassword,
  setNewPassword,
  onReset
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-gray-800 border-gray-700 text-white">
      <DialogHeader>
        <DialogTitle>Reset Password</DialogTitle>
        <DialogDescription className="text-gray-400">
          Reset password for {selectedUser?.username}
        </DialogDescription>
      </DialogHeader>
      <div className="py-4">
        <Label htmlFor="new-password" className="text-white mb-2 block">
          New Password (min. 8 characters)
        </Label>
        <Input
          id="new-password"
          type="password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          className="bg-gray-900 border-gray-600 text-white"
          placeholder="Enter new password"
        />
      </div>
      <DialogFooter>
        <Button
          variant="outline"
          onClick={() => onOpenChange(false)}
          className="border-gray-600"
        >
          Cancel
        </Button>
        <Button
          onClick={onReset}
          className="bg-gradient-to-r from-yellow-400 to-purple-500"
        >
          Reset Password
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export const ChangeRoleDialog = ({
  open,
  onOpenChange,
  selectedUser,
  newRole,
  setNewRole,
  onChange
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-gray-800 border-gray-700 text-white">
      <DialogHeader>
        <DialogTitle>Change User Role</DialogTitle>
        <DialogDescription className="text-gray-400">
          Change role for {selectedUser?.username}
        </DialogDescription>
      </DialogHeader>
      <div className="py-4">
        <Label htmlFor="role" className="text-white mb-2 block">
          Select Role
        </Label>
        <Select value={newRole} onValueChange={setNewRole}>
          <SelectTrigger className="bg-gray-900 border-gray-600 text-white">
            <SelectValue placeholder="Select a role" />
          </SelectTrigger>
          <SelectContent className="bg-gray-800 border-gray-700 text-white">
            <SelectItem value="user">User</SelectItem>
            <SelectItem value="artist">Artist</SelectItem>
            <SelectItem value="moderator">Moderator</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <DialogFooter>
        <Button
          variant="outline"
          onClick={() => onOpenChange(false)}
          className="border-gray-600"
        >
          Cancel
        </Button>
        <Button
          onClick={onChange}
          className="bg-gradient-to-r from-yellow-400 to-purple-500"
        >
          Update Role
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export const EditUserDialog = ({
  open,
  onOpenChange,
  selectedUser,
  editForm,
  setEditForm,
  onSave
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-gray-800 border-gray-700 text-white">
      <DialogHeader>
        <DialogTitle>Edit User Profile</DialogTitle>
        <DialogDescription className="text-gray-400">
          Edit profile details for {selectedUser?.username}
        </DialogDescription>
      </DialogHeader>
      <div className="py-4 space-y-4">
        <div>
          <Label className="text-white mb-2 block">Username</Label>
          <Input
            value={editForm.username}
            onChange={(e) => setEditForm({...editForm, username: e.target.value})}
            className="bg-gray-900 border-gray-600 text-white"
          />
        </div>
        <div>
          <Label className="text-white mb-2 block">Email</Label>
          <Input
            value={editForm.email}
            onChange={(e) => setEditForm({...editForm, email: e.target.value})}
            className="bg-gray-900 border-gray-600 text-white"
          />
        </div>
        <div>
          <Label className="text-white mb-2 block">Display Name</Label>
          <Input
            value={editForm.display_name}
            onChange={(e) => setEditForm({...editForm, display_name: e.target.value})}
            className="bg-gray-900 border-gray-600 text-white"
          />
        </div>
        <div>
          <Label className="text-white mb-2 block">Phone</Label>
          <Input
            value={editForm.phone}
            onChange={(e) => setEditForm({...editForm, phone: e.target.value})}
            className="bg-gray-900 border-gray-600 text-white"
          />
        </div>
        <div>
          <Label className="text-white mb-2 block">Bio</Label>
          <Textarea
            value={editForm.bio}
            onChange={(e) => setEditForm({...editForm, bio: e.target.value})}
            className="bg-gray-900 border-gray-600 text-white"
            rows={3}
          />
        </div>
      </div>
      <DialogFooter>
        <Button
          variant="outline"
          onClick={() => onOpenChange(false)}
          className="border-gray-600"
        >
          Cancel
        </Button>
        <Button
          onClick={onSave}
          className="bg-gradient-to-r from-yellow-400 to-purple-500"
        >
          Save Changes
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
